import { render, staticRenderFns } from "./CenterViewSampleUpload_Ap.vue?vue&type=template&id=718c442a&scoped=true"
import script from "./CenterViewSampleUpload_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewSampleUpload_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewSampleUpload_Ap.vue?vue&type=style&index=0&id=718c442a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c442a",
  null
  
)

export default component.exports